import React from 'react'

import {Button} from '@mui/material'

import i18next from 'i18next'

import * as UE from '../UiElements'
import { LabelProps, translateLabel } from '../I18n/TranslateLabel'

interface ClickObject<T = any> {
    param: any
    cb: (obj: any) => void
}

export interface ButtonProps extends LabelProps{
    layout?: UE.UiLayout
    label?: string
    tlabel?: string // Translated label

    href?: string
    target?: string

    default?: boolean

    onClick?: () => void
    onClickTrue?: (p: boolean) => void

    onClickParam?: ClickObject
}

export function PageButton(props: ButtonProps) {
    const [buttonLabel] = React.useState(translateLabel(props))
    const [layoutSx] = React.useState(props.layout ? props.layout.sx() : {})
    const [variant] = React.useState<'outlined' | 'contained'>(
        props.default === true ? 'contained' : 'outlined'
    )

    const handleClick = React.useCallback(() => {
        props.onClick && props.onClick()
        props.onClickTrue && props.onClickTrue(true)
        props.onClickParam && props.onClickParam.cb(props.onClickParam.param)
    }, [])

    if (props.href) {
        return (
            <Button variant={variant} target={props.target} href={props.href} sx={layoutSx}>
                {buttonLabel}
            </Button>
        )
    }

    // Designed component
    //
    return (
        <Button variant={variant} onClick={handleClick} sx={layoutSx}>
            {buttonLabel}
        </Button>
    )
}
